module.exports = __webpack_public_path__ + "static/img/181002-gene-mutation.76937b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181002-gene-mutation.jpg
// module id = boen
// module chunks = 0